module.exports = __webpack_public_path__ + "images/emoji/restroom.e142eb367dc99e88bb4e.png";